import { Box, styled } from '@mui/material';
import { GRID_CONTAINER_BORDER_WIDTH } from 'src/constants';

const screenBorderWidth = 5;

export const AssemblyLayoutContainer = styled(Box)(
  ({ $type, $scale }) => `
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > div:nth-child(n + 2) {
    border-left-width: ${
      $type === 'grid'
        ? GRID_CONTAINER_BORDER_WIDTH * $scale
        : screenBorderWidth
    }px;
    margin-left: -${
      $type === 'grid'
        ? GRID_CONTAINER_BORDER_WIDTH * $scale
        : screenBorderWidth
    }px;
  }
`,
);
